<template>
  <v-container fluid fill-height class="pa-0">
    <v-row class="header-section position-relative">
        <v-col cols="2" class="align-items-center d-none d-sm-block">
          <v-img
            :src="require('@/assets/img/icons/challenge-detail/desafios-home.png')"
            height="120"
            width="145"
            class="img-titles-absolute">
          </v-img>
        </v-col>
        <v-col>
          <h3>{{ $t('challenge.take_a_challenge_and_earn_rewards') }}</h3>
          <p>{{ $t('challenge.test_your_reading_skills') }}</p>
        </v-col>
      </v-row>
      <v-card dark class="bg-purple pt-0 border-radius-2 w-100 min-h-card position-relative">
          <!-- <v-row class="fill-height "> -->
          <v-btn
              icon
              class="btn-detail-table pa-1 pa-md-2"
              :height="$vuetify.breakpoint.md ? '24' : '18'"
              :width="$vuetify.breakpoint.md ? '24' : '18'"
              @click="openDialog">
              <v-img
                  :src="imgInfo"
                  :height="$vuetify.breakpoint.md ? '24' : '18'"
                  :width="$vuetify.breakpoint.md ? '24' : '18'"
                  alt="Mostrar tabla de detalle"
                  class="">
              </v-img>
          </v-btn>
          <v-row class="center-card">
              <v-col cols="4" sm="auto" class="d-flex text-end pr-0 py-0">
                  <v-img
                    :src="require('@/assets/img/icons/do-challenge.png')"
                    class="book-icon"
                    contain>
                  </v-img>
              </v-col>
              <v-col cols="8" sm="auto" class="d-flex align-items-center flex-column pl-0 py-0">
                  <v-row class="w-100 text-start align-items-center">
                      <v-col class=" pa-0">
                          <v-chip
                              label
                              x-small
                              color="white"
                              class="font-weight-bold primary--text px-2 py-3 text-uppercase"
                          >Lectura</v-chip>

                      </v-col>
                  </v-row>
                  <v-row class="w-100 text-start align-items-start">
                    <v-col class="pa-0">
                      <v-btn
                      data-cy="start_challenge_btn"
                      outlined
                      rounded
                      small
                      color="white"
                      class="text-lowercase"
                      @click="startChallenge">
                          <v-icon small>mdi mdi-play</v-icon>
                          <span class="first-letter-uppercase">{{ $t('challenge.start_challenge') }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
              </v-col>
          </v-row>
      </v-card>
  </v-container>
</template>

<script>
import initialReaderValidation from '@/mixins/InitialReaderValidation'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      imgInfo: require('@/assets/img/icons/icon-help.svg'),
    }
  },
  computed: {
    ...mapState({
      course: (state) => state.userData.user.course,
    }),
  },
  methods: {
    ...mapActions('challenge', [
        'setChallengeStage',
        'setReadingTime',
        'setReReadingTime',
        'resetTimers',
        'startReading'
    ]),
    startChallenge(){
        if(this.$route.name !== 'challenge'){
            this.$router.push('/user/challenge')
            // this.loaded = false;
            this.goToChallenge()
          } else {
            this.setChallengeStage('runChallenge')
            this.resetTimers()
            this.startReading()
          }
        },
    openDialog() {
      this.$root.$emit('openDialog', true);
    },
    goToChallenge() {
      setTimeout(() => {
        this.setChallengeStage('runChallenge')
        this.resetTimers()
        this.startReading()
      }, 1500)
    },
  },
  mixins: [initialReaderValidation]
}
</script>

<style lang="scss">
.bg-purple{
  background: #514585;
  background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%)!important;
  border: 0;
}
.btn-detail-table{
    position: absolute;
    top: 1em;
    right: 1em;
    z-index: 5;
}
.img-overlay{
  right: -15px;
}
.min-h-card{
  min-height: 130px;

  @media screen and (max-width: 960px) {
    height: auto;
  }
}
.img-titles-absolute{
  position: absolute;
  top: -10px;
  left: -1em;
}
.center-card{
  position:absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  @media screen and (min-width: 640px) {
    max-width: 320px;
  }
}
.book-icon{
  width: 100%;
  min-width: 100px;
  max-width: 135px;
}
</style>
